/* tslint:disable */
/* eslint-disable */
/**
 * Swipe4Work Employer API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Check if a given object implements the CreateEmployerCommandDto interface.
 */
export function instanceOfCreateEmployerCommandDto(value) {
    if (!('inviteId' in value) || value['inviteId'] === undefined)
        return false;
    if (!('firstName' in value) || value['firstName'] === undefined)
        return false;
    if (!('lastName' in value) || value['lastName'] === undefined)
        return false;
    if (!('password' in value) || value['password'] === undefined)
        return false;
    return true;
}
export function CreateEmployerCommandDtoFromJSON(json) {
    return CreateEmployerCommandDtoFromJSONTyped(json, false);
}
export function CreateEmployerCommandDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'inviteId': json['inviteId'],
        'firstName': json['firstName'],
        'lastName': json['lastName'],
        'password': json['password'],
    };
}
export function CreateEmployerCommandDtoToJSON(json) {
    return CreateEmployerCommandDtoToJSONTyped(json, false);
}
export function CreateEmployerCommandDtoToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'inviteId': value['inviteId'],
        'firstName': value['firstName'],
        'lastName': value['lastName'],
        'password': value['password'],
    };
}
